import { render, staticRenderFns } from "./SugestaoEstoqueEstetico.vue?vue&type=template&id=7da1bf7c&scoped=true"
import script from "./SugestaoEstoqueEstetico.vue?vue&type=script&lang=js"
export * from "./SugestaoEstoqueEstetico.vue?vue&type=script&lang=js"
import style0 from "./SugestaoEstoqueEstetico.vue?vue&type=style&index=0&id=7da1bf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1bf7c",
  null
  
)

export default component.exports